// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DingtalkOutlinedSvg from "@fishx/icons-svg/es/asn/DingtalkOutlined";
import FishxIcon from '../components/FishxIcon';

var DingtalkOutlined = function DingtalkOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DingtalkOutlinedSvg
  }));
};

DingtalkOutlined.displayName = 'DingtalkOutlined';
export default React.forwardRef(DingtalkOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DingtalkOutlined.js
// module id = 2424
// module chunks = 0